/**
 * If failOnStatuses is null, then throws an error on ANY not OK response (including 401)
 * If not null, then throw error on positive statuses and ignore negative statuses.
 * That is [-404] means throw on everything but 404. [401] means throw only on 401.
 * You should not mix positive and negative numbers. That is [-404, 401] doesn't make sense.
 * 
 * @export
 * @param {Response} response 
 * @returns {Response}
 */
export function failOnNotOk(response: Response, failOnStatuses: number[]) {
	if (response.ok)
		return response;

	// default - fail on everything
	if (!failOnStatuses)
		throw Error(response.statusText);
	// otherise if it's an error you care about, fail
	else if (failOnStatuses.indexOf(response.status) >= 0)
		throw Error(response.statusText);
	// otherwise, if you explicitly want to ignore _anything_ and the current error
	// is not one you explicitly want to ignore, fail
	else if (failOnStatuses.some(e => e < 0) && failOnStatuses.indexOf(response.status * -1) == -1)
		throw Error(response.statusText);

	return response;
}

export function responseAsJson<T>(response: Response): Promise<T> {
	return response.json().then(r => r as T).catch(err => <T>null);
}


// WEBPACK FOOTER //
// ./src/utils/fetch-helper.ts